import { render, staticRenderFns } from "./private-commercial-proposals-block.vue?vue&type=template&id=185f07ea&"
import script from "./private-commercial-proposals-block.vue?vue&type=script&lang=js&"
export * from "./private-commercial-proposals-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185f07ea')) {
      api.createRecord('185f07ea', component.options)
    } else {
      api.reload('185f07ea', component.options)
    }
    module.hot.accept("./private-commercial-proposals-block.vue?vue&type=template&id=185f07ea&", function () {
      api.rerender('185f07ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/partials/private-commercial-proposals-block.vue"
export default component.exports